import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getUser } from '@/utils/auth';

/**
 * Authentication Store
 * Global state management for authentication
 */

const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: getUser(),
      isAuthenticated: !!getUser(),
      isLoading: false,
      error: null,

      // Actions
      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
          error: null,
        }),

      setLoading: (isLoading) => set({ isLoading }),

      setError: (error) => set({ error }),

      clearAuth: () =>
        set({
          user: null,
          isAuthenticated: false,
          error: null,
        }),

      logout: () => {
        set({
          user: null,
          isAuthenticated: false,
          error: null,
        });
      },

      updateUser: (updates) =>
        set((state) => ({
          user: { ...state.user, ...updates },
        })),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAuthStore;
